import ButtonPlay from './button-play.component';
export default ButtonPlay;